import { createFileRoute } from '@tanstack/react-router';
import { redirectToPastVideoGroup } from '@/features/past-videos/redirects';

// The old address of one group (before 16 Oct 2026): its own page now, keeping the check, the video and the view
// (brief memory's reasons and any bookmark keep working).
export const Route = createFileRoute('/_authed/review/past-videos/$setId')({
  beforeLoad: redirectToPastVideoGroup,
});
